import React, { Component } from "react";
import Modal from "react-responsive-modal";
import { createApi } from "unsplash-js";
import axios from "axios";
import { FilePond } from "react-filepond";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Input } from "../../revvComponents";

import { API_ENDPOINTS, EVENTS, IMAGE_URLS } from "../../constants";
import "filepond/dist/filepond.min.css";
import { AmplitudeUtils } from "../../utils";

const { APIS } = API_ENDPOINTS;

const clientIdKey = "bHdNEQJ_sfk5RYLCYs4dWs2x28BmBrIynlYZT7BkR30";

const { EVENT_NAMES } = EVENTS;
const { UNSPLASH_LOGO } = IMAGE_URLS;
const { amplitudeLogEvent } = AmplitudeUtils;

const unsplash = createApi({
  accessKey: clientIdKey,
});

// eslint-disable-next-line react/prefer-stateless-function
class ImageChangePopup extends Component {
  state = {
    imagesData: "",
    pageNumber: 1,
    showUpload: this.props.type === "imageComponent",
    buttonLoading: false,
    filterName: "",
    lastUploadedImageFileName: "",
  };

  componentDidMount() {
    this.state.buttonLoading = true;
    let params = {};
    if (this.props.type === "imageComponent") {
      params = {
        page: this.state.pageNumber,
        query: "business",
        client_id: clientIdKey,
        per_page: 28,
      };
    } else {
      params = {
        page: this.state.pageNumber,
        query: "business",
        client_id: clientIdKey,
        per_page: 28,
        orientation: "portrait",
      };
    }
    axios
      .get(`${APIS.UNSPLASH_BASEURL}`, {
        params: {
          ...params,
        },
      })
      .then(res => {
        this.setState({
          imagesData: res.data.results,
          buttonLoading: false,
        });
      })
      .catch(error => {
        console.debug(error);
      });
  }

  _loadMoreImages = () => {
    const currentPage = this.state.pageNumber;
    if (currentPage < 5) {
      let params = {};
      if (this.props.type === "imageComponent") {
        params = {
          page: currentPage + 1,
          query:
            this.state.filterName !== "" ? this.state.filterName : "Business",
          client_id: clientIdKey,
          per_page: 28,
        };
      } else {
        params = {
          page: currentPage + 1,
          query:
            this.state.filterName !== "" ? this.state.filterName : "Business",
          client_id: clientIdKey,
          per_page: 28,
          orientation: "portrait",
        };
      }
      this.state.buttonLoading = true;
      axios
        .get(`${APIS.UNSPLASH_BASEURL}`, {
          params: {
            ...params,
          },
        })
        .then(res => {
          this.setState(prevState => ({
            imagesData: [...prevState.imagesData, ...res.data.results],
            pageNumber: prevState.pageNumber + 1,
            buttonLoading: false,
          }));
        })
        .catch(error => {
          console.debug(error);
        });
    }
    amplitudeLogEvent(EVENT_NAMES.UNSPLASH_LOAD_MORE_BUTTON_CLICKED, {});
  };

  _filterImages = e => {
    this.setState({
      filterName: e.target.value,
    });
  };

  _onConfirmation = () => {
    this.state.buttonLoading = true;
    const { filterName } = this.state;
    let params = {};
    if (this.props.type === "imageComponent") {
      params = {
        page: 1,
        query: filterName,
        client_id: clientIdKey,
        per_page: 28,
      };
    } else {
      params = {
        page: 1,
        query: filterName,
        client_id: clientIdKey,
        per_page: 28,
        orientation: "portrait",
      };
    }
    axios
      .get(`${APIS.UNSPLASH_BASEURL}`, {
        params: {
          ...params,
        },
      })
      .then(res => {
        this.setState({
          imagesData: res.data.results,
          pageNumber: 1,
          buttonLoading: false,
        });
      })
      .catch(error => {
        console.debug(error);
      });
    amplitudeLogEvent(EVENT_NAMES.UNSPLASH_SEARCH_IMAGES, {});
  };

  _downloadEndpointRequest = image => {
    unsplash.photos.trackDownload({
      downloadLocation: image.links.download_location,
    });
  };

  _uploadActive = () => {
    this.setState({
      showUpload: true,
    });
  };

  _unsplashActive = () => {
    this.setState({
      showUpload: false,
    });
    amplitudeLogEvent(EVENT_NAMES.UNSPLASH_BUTTON_CLICKED, {});
  };

  _onUploadImage = evt => {
    if (
      Array.isArray(evt) &&
      evt.length > 0 &&
      this.state.lastUploadedImageFileName !== evt[0].filename
    ) {
      this.setState(
        {
          lastUploadedImageFileName: evt[0].filename,
        },
        () => {
          this.props.uploadDocument(evt);
        },
      );
    }
  };

  render() {
    let uploadActive = "";
    let unsplashActive = " active";
    if (this.state.showUpload) {
      uploadActive = " active";
      unsplashActive = "";
    } else if (!this.state.showUpload) {
      unsplashActive = " active";
      uploadActive = "";
    }
    let errSpace = null;
    if (this.props.errMsg && this.props.errMsg !== "") {
      errSpace = (
        <div className="error-message-wrapper">
          <span className="error-message-icon">
            <FontAwesomeIcon icon={["far", "times-circle"]} />
          </span>
          {this.props.errMsg}
        </div>
      );
    }

    return (
      <Modal
        open={this.props.show}
        onClose={this.props.onCloseImagePopup}
        closeOnOverlayClick={false}
        center>
        <div className="image-change-popup-wrapper">
          <div className="image-change-heading">Import Image</div>
          {errSpace}
          <div className="image-change-popup-body">
            <div className="image-change-popup-leftpane">
              <span
                data-test="imagechangepopup-image-upload-btn"
                className={`image-upload-btn${uploadActive}`}
                role="button"
                tabIndex={0}
                onClick={this._uploadActive}
                onKeyPress={() => {}}>
                <i>
                  <FontAwesomeIcon icon={["far", "upload"]} />
                </i>
                Upload Image
              </span>
              {/* <span
                className="image-upload-btn"
                role="button"
                tabIndex={0}
                onClick={() =>
                  this.setState({
                    showUpload: true,
                  })
                }
                onKeyPress={() => {}}>
                <i>
                  <FontAwesomeIcon icon={["far", "images"]} />
                </i>
                My gallery
              </span> */}
              <span
                data-test="imagechangepopup-image-unsplash-btn"
                className={`image-upload-btn${unsplashActive}`}
                role="button"
                tabIndex={0}
                onClick={this._unsplashActive}
                onKeyPress={() => {}}>
                <img
                  src={UNSPLASH_LOGO}
                  className="unsplash-logo"
                  alt="unsplash logo"
                />
                Unsplash <span className="new-tag">New</span>
              </span>
            </div>
            {!this.state.showUpload ? (
              <div className="image-change-popup-rightpane">
                <span className="image-heading">
                  Choose from 1000+ free background images for your cover page{" "}
                  <span className="unsplash-credit">
                    - powered by
                    <a
                      href="https://unsplash.com/"
                      className="unsplash-link"
                      target="blank"
                      data-test="unsplash-credit-image-upload">
                      {" "}
                      Unsplash
                    </a>
                  </span>
                </span>
                <div className="unsplash-search">
                  <Input
                    placeholder="Search for 'Teams' and press enter"
                    autoFocus
                    onChange={e => this._filterImages(e)}
                    onKeyDown={e => {
                      if (e.key === "Enter") {
                        this._onConfirmation();
                      }
                    }}
                    value={this.state.filterName}
                    data-test="unsplash-search-image"
                  />
                </div>
                <div className="unsplash-wrapper">
                  <div className="unsplash-image-card">
                    {this.state.imagesData !== ""
                      ? this.state.imagesData.map(image => (
                          <div className="unsplash-image-thumbnailwrapper">
                            <div
                              className="unsplash-image-thumbnail"
                              role="button"
                              tabIndex={0}
                              onClick={() => {
                                this.props.uploadDocument(image.urls);
                                this._downloadEndpointRequest(image);
                              }}
                              onKeyPress={() => {}}>
                              <img
                                src={image.urls.thumb}
                                alt={image.alt_description}
                              />
                            </div>
                            <div>
                              <span className="unsplash-credits">
                                by{" "}
                                <a
                                  href={`${image.user.links.html}?utm_source=Revv.so&utm_medium=referral`}
                                  target="blank"
                                  data-test="unsplash-credits-image">
                                  {image.user.name}
                                </a>
                              </span>
                            </div>
                          </div>
                        ))
                      : null}
                  </div>

                  <div
                    role="button"
                    tabIndex={0}
                    className="load-images-info"
                    onClick={() => this._loadMoreImages()}
                    onKeyPress={() => {}}>
                    {this.state.buttonLoading
                      ? "Loading..."
                      : "Click for load more images"}
                  </div>
                </div>
              </div>
            ) : null}
            {this.state.showUpload ? (
              <div className="upload-image-area">
                <FilePond
                  allowMultiple={false}
                  onupdatefiles={this._onUploadImage}
                  labelIdle="Drag & drop image files or <u>browse</u> to upload"
                />
              </div>
            ) : null}
          </div>
          {/* <div className="image-change-popup-footer">
            <span>Insert</span>
            <span>Cancel</span>
          </div> */}
        </div>
      </Modal>
    );
  }
}

export default ImageChangePopup;
